import type { ModuleManifest } from "./types";

export const offersManifest: ModuleManifest = {
  name: "offers",
  label: "Offer",
  labelPlural: "Offers",

  coreBOSModule: "cbOffers",
  wsidPrefix: "65x",

  type: "master-detail",
  detailModule: "offer-details",
  masterField: "cboffers_relation",

  routes: {
    list: "/offers",
    show: "/offers/show/:id",
    create: "/offers/create",
    edit: "/offers/edit/:id",
  },

  navigation: {
    icon: "SolutionOutlined",
    order: 7,
    group: "Sales",
  },

  routing: {
    keywords: [
      "offer",
      "offers",
      "quote",
      "quotes",
      "proposal",
      "proposals",
      "preventivo",
      "preventivi",
    ],
    searchFields: ["subject", "offer_number"],
    defaultSort: { field: "createdtime", order: "desc" },
  },

  context: {
    supported: true,
    entityKey: "offers",
  },

  fields: [
    { name: "subject", label: "Subject", type: "string", required: true },
    {
      name: "offer_number",
      label: "Offer Number",
      type: "string",
      readonly: true,
    },
    {
      name: "version_number",
      label: "Version",
      type: "string",
      readonly: true,
    },
    {
      name: "offer_status",
      label: "Status",
      type: "picklist",
      options: [
        { value: "Draft", label: "Draft" },
        { value: "Sent", label: "Sent" },
        { value: "Accepted", label: "Accepted" },
        { value: "Rejected", label: "Rejected" },
      ],
    },
    { name: "expiration_date", label: "Expiration Date", type: "date" },
    { name: "expected_close_date", label: "Expected Close Date", type: "date" },
    {
      name: "related_account",
      label: "Account",
      type: "reference",
      referenceModule: "Accounts",
    },
    {
      name: "related_potential",
      label: "Opportunity",
      type: "reference",
      referenceModule: "Potentials",
    },
    {
      name: "related_client",
      label: "Contact",
      type: "reference",
      referenceModule: "Contacts",
    },
    {
      name: "success_chance",
      label: "Success Chance",
      type: "picklist",
      options: [
        { value: "High", label: "High" },
        { value: "Medium", label: "Medium" },
        { value: "Low", label: "Low" },
      ],
    },
    {
      name: "assigned_user_id",
      label: "Assigned To",
      type: "reference",
      referenceModule: "Users",
      hidden: true,
      defaultValue: "19x1",
    },
  ],

  relationships: [
    {
      module: "cbOfferDetail",
      field: "cboffers_relation",
      relation: "one-to-many",
      label: "Line Items",
      icon: "UnorderedListOutlined",
      displayField: "related_product",
    },
    {
      module: "Accounts",
      field: "related_account",
      label: "Account",
      icon: "BankOutlined",
      displayField: "accountname",
    },
    {
      module: "Potentials",
      field: "related_potential",
      label: "Opportunity",
      icon: "TrophyOutlined",
      displayField: "potentialname",
    },
    {
      module: "Documents",
      relation: "many-to-many",
      label: "Documents",
      icon: "FileOutlined",
      displayField: "notes_title",
    },
  ],

  requiredFields: ["subject", "assigned_user_id"],

  massEdit: {
    enabled: true,
  },
};
